<template>
  <div class="main_center">
    <div class="content">
      <div class="search-content">
        <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
          <div class="search-drawer">
            <el-form label-position="top" :model="moreSearchForm">
              <el-form-item label="数据所属部门：">
                <select-depart-tree ref="selectDepartTreeRef" :type="'2'"
                  :modelValue.sync="moreSearchForm.superviseDeptCodeList" :isMultiple="true"
                  @handleDeptType="(val) => changeDept(val, '5')">
                </select-depart-tree>
              </el-form-item>
            </el-form>
            <div class="search-drawer__footer">
              <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
              <el-button @click="refresh" plain size="small">重置</el-button>
            </div>
          </div>

        </searchBox>
        <el-form ref="expertForm" class="conditionForm" :model="expertForm" label-width="0px">
          <el-row>
            <!-- <el-col :span="6" :offset="1">
                <el-form-item label="" props="profName">
                  <el-input v-model="expertForm.profName" clearable placeholder="请输入姓名/身份证号码"
                            @keyup.enter.native="handleSearch"></el-input>
                </el-form-item>
            </el-col>-->
            <div style="display:flex;justify-content:flex-end;margin-bottom:20px;margin-right:15px">
              <el-input v-model="expertForm.profName" clearable placeholder="请输入姓名/身份证号码"
                @keyup.enter.native="handleSearch" style="width:300px"></el-input>
              <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
              <el-button size="mini" type="text" @click="moreSearchItem = true">更多搜索<i
                  class="el-icon-arrow-down"></i></el-button>
              <el-button plain size="small" @click="handleRefresh">重置</el-button>
            </div>
            <!-- <div class="searchBtn" >
              <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
              <el-button plain size="small" @click="handleRefresh">重置</el-button>
            </div>-->
          </el-row>
        </el-form>
      </div>
      <div class="expert_Table">
        <el-table ref="multipleTable" :key="tableKey" class="table-content" :data="tableData"
          v-loading="dataListLoading" :height="tableMaxHeight" stripe border
          :header-cell-style="this.$globalGrayTableHeaderStyle" @sort-change="sortChange">
          <el-table-column label="序号" type="index" width="50" align="center"
            :show-overflow-tooltip="true"></el-table-column>

          <el-table-column label="姓名" prop="profName" header-align="center" align="center" min-width="80"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.showDetailInfo">
                {{ scope.row.nameReal }}
                <el-button @click="showItemDetail(scope.row, scope.$index, false)" size="small"
                  style="vertical-align: middle" type="text">
                  <icon-svg class="svg-icon" name="openeye"></icon-svg>
                </el-button>
              </span>
              <span v-else>
                {{ scope.row.profName }}
                <el-button @click="showItemDetail(scope.row, scope.$index, true)" size="small"
                  style="vertical-align: middle" type="text">
                  <icon-svg class="svg-icon" name="closeeye"></icon-svg>

                </el-button>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="身份证号" prop="idCard" header-align="center" align="center" min-width="100"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.showDetailInfo">
                {{ scope.row.idcardReal }}
                <el-button @click="showItemDetail(scope.row, scope.$index, false)" size="small"
                  style="vertical-align: middle" type="text">
                  <icon-svg class="svg-icon" name="openeye"></icon-svg>
                </el-button>
              </span>
              <span v-else>
                {{ scope.row.idCard }}
                <el-button @click="showItemDetail(scope.row, scope.$index, true)" size="small"
                  style="vertical-align: middle" type="text">
                  <icon-svg class="svg-icon" name="closeeye"></icon-svg>
                </el-button>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="接受邀请次数（累计）" prop="inviteCount" header-align="center" align="center" min-width="100"
            :show-overflow-tooltip="true" sortable></el-table-column>

          <el-table-column label="实际参评次数（累计）" prop="participateCount" header-align="center" align="center"
            min-width="100" :show-overflow-tooltip="true" sortable></el-table-column>

          <el-table-column label="接受邀请次数（本年）" prop="inviteYearCount" header-align="center" align="center"
            min-width="100" :show-overflow-tooltip="true" sortable></el-table-column>
          <el-table-column label="实际参评次数（本年）" prop="participateYearCount" header-align="center" align="center"
            min-width="100" :show-overflow-tooltip="true" sortable></el-table-column>
          <el-table-column label="最近一次评标时间" prop="lastEvaluationDate" header-align="center" align="center"
            min-width="100" :show-overflow-tooltip="true" sortable>
            <template slot-scope="scope">
              <div style="color: rgb(0, 153, 255); ">{{ scope.row.lastEvaluationDate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="专家评价平均得分" header-align="center" align="center" sortable min-width="100">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.value" :allow-half="true" disabled text-color="#f4ea2a"></el-rate>
            </template>
          </el-table-column>

          <!-- <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" title="查看" @click="getDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination background layout="total, sizes, prev, pager, next" :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize" :total="total" :current-page="pageIndex" @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"></el-pagination>
      </div>
      <!-- <bottom-echarts
        :superviseDeptCodeList="moreSearchForm.superviseDeptCodeList.length == 0 ? this.uerdefultOptionCode : moreSearchForm.superviseDeptCodeList"></bottom-echarts> -->
    </div>
  </div>
</template>
<script>
import BottomEcharts from "./common/CountTotalEcharts.vue";
import { getevaluationRecordList, getViewDetil } from "@/server/exports";
import { mapState } from "vuex";
import selectDepartTree from "@/views/modules/components/selectDepartTree"
export default {
  name: "expertTable",
  components: {
    BottomEcharts,
    selectDepartTree
  },
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 260,
      dataListLoading: false,
      expertForm: {
        profName: "",
        idCard: "",
        tradeId: ''
      },
      tableKey: Math.random(),
      sortParams: {
        order: "descending",
        prop: "participateCount"
      },
      tableData: [],
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 10,//总条数
      moreSearchItem: false,
      moreSearchForm: {
        superviseDeptCodeList: []
      },
    };
  },

  watch: {
    uerdefultOptionCode: {
      handler(val, oldVal) {
        if (val.length !== 0) {
          this.getDataList();
        }
      }
    }
  },
  computed: {
    ...mapState({
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
      isAdmin: state => { return state.user.userinfo.selectRoleCode == "ADMIN" }
    })
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    //专家评审记录列表
    getDataList() {
      this.dataListLoading = true;
      this.tableData = [];
      getevaluationRecordList({
        page: this.pageIndex,
        rows: this.pageSize,
        searchKey: this.expertForm.profName,
        orderBy:
          this.sortParams.prop && this.sortParams.order

            ? this.sortParams.prop +
            (this.sortParams.order == "ascending" ? " asc" : " desc")
            : "",
        filter: { superviseDeptCodeList: this.moreSearchForm.superviseDeptCodeList.length == 0 ? this.uerdefultOptionCode : this.moreSearchForm.superviseDeptCodeList }
      }).then(res => {
        if (res.data) {
          this.tableKey = Math.random();
          let rowsData = res.data.rows || [];
          rowsData.forEach(item => {
            item.showDetailInfo = false;
          });
          this.tableData = rowsData;
          this.total = res.data.total;
          this.dataListLoading = false;
          // this.$nextTick(()=>{
          //   this.$refs.multipleTable.doLayout();
          //  })
        }
      });
    },
    changeDept(val, str) {//切换部门
      this.moreSearchForm.superviseDeptCodeList = []
      if (str === '5') {
        // 多选
        val.forEach((item, index) => {
          if (item.type !== "region") {
            this.moreSearchForm.superviseDeptCodeList.push(item.code)
          }
        })
      }
    },
    dialogCancle() {
      this.moreSearchItem = false
    },
    sortChange(column, prop, order) {
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getDataList();
    },
    showItemDetail(row, index, boolean) {
      if (boolean && !row.idcardReal) {
        getViewDetil(row.id).then(res => {
          if (res.data.code == 1) {
            this.tableData[index].showDetailInfo = true;
            this.tableData[index].idcardReal = res.data.data.idCard;
            this.tableData[index].nameReal = res.data.data.profName;
            this.tableData = JSON.parse(JSON.stringify(this.tableData));
            this.$refs.multipleTable.doLayout();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        this.tableData[index].showDetailInfo = boolean;
        this.tableData = JSON.parse(JSON.stringify(this.tableData));
        this.$refs.multipleTable.doLayout();
      }
    },
    //搜索按钮
    handleSearch() {
      this.pageIndex = 1;
      this.getDataList();
    },
    handleRefresh() {
      //刷新按钮
      this.pageIndex = 1;
      this.expertForm.profName = "";
      this.expertForm.idCard = "";
      this.expertForm.tradeId = '';
      this.getDataList();
    },
    searchBtn() {
      this.pageIndex = 1;
      this.getDataList();
    },
    refresh() {
      this.moreSearchForm.superviseDeptCodeList = []
      // 重置默认所属数据
      if (this.$refs.selectDepartTreeRef) {
        this.$refs.selectDepartTreeRef.getUserTreeOption()
      }
      this.searchBtn();
    },
    //分页---------------------------------------------------
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    getDetail(item) {
      // 跳转详情
      const id = item.id;
      this.$router.push({
        name: "experts_detail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style>
.overShow {
  overflow: auto;
}
</style>
